import * as React from 'react';
import Link from '@mui/material/Link';
import PlaceIcon from '@mui/icons-material/Place';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Typography } from '@mui/material';
import MapLink from 'components/MapLink';

const tap151ParkingMapLink = "https://maps.app.goo.gl/WakAsofXRFGbYmCM7";

type Tap151ParkingMapLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: Tap151ParkingMapLinkProps = {
  linkText: "222 Jacob St, Cambridge, MA 02141",
  underline: "hover"
};

export default function Tap151ParkingMapLink(linkProps: Tap151ParkingMapLinkProps = defaultProps) {
  const linkText = linkProps.linkText || defaultProps.linkText || "";
  const underline = linkProps.underline || defaultProps.underline; 
  return (
    <Box sx={{display: "inline-block", textAlign: "center"}}>
      <MapLink linkUrl={tap151ParkingMapLink} underline={underline} >{linkText}</MapLink>
      <br />
      (Follow signs for "Retail Parking")
    </Box>
  );
}